import { useHeap, type HeapRequiredUserProperties } from "@newsela/snitch";

import useUser from "@/users/useUser";

const HeapTrackingContainer = () => {
  const { data: user } = useUser();

  /**
   * Shaped object of user properties necessary to send to heap
   */
  const heapUser: HeapRequiredUserProperties = {
    unique_id: user?.id,
    licenses: user?.licenses,
    classroom_grade_levels: user?.classroom_grade_levels,
    date_joined: user?.date_joined,
    id: user?.id,
    email: user?.email,
    is_demo: user?.is_demo,
    is_staff: user?.is_staff,
    is_authenticated: user?.is_authenticated,
    features: user?.features,
    student: user?.student,
    teacher: user?.teacher,
    district_admin: user?.district_admin,
    principal: user?.principal,
  };

  useHeap(heapUser);
  return null;
};

export default HeapTrackingContainer;
